import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Text, Image } from "@base";
import { useFooterData } from "@staticQueries";
import { PageStateContext } from "../PageContext";
import { debugLog } from "../utils/index";
// Memoized Footer component
const Footer = ({ onFirstPage = false }) => {
  const { logo, companyName, contact } = useFooterData();
  const { pageState } = useContext(PageStateContext);

  if (!pageState || !pageState.chrome) {
    return (
      <div className="header-loading">
        <span>Loading Footer...</span>
      </div>
    );
  }
  const { chrome, uiText } = pageState;
  const { color = "#000000" } = chrome;
  debugLog("footer chrome", chrome);
  debugLog("footer uiText", uiText);
  return (
    <footer
      className={`Footer Footer--${onFirstPage ? "first" : "not-first"}`}
      style={{ height: 70, paddingTop: 20 }}
    >
      <div
        className="flex items-center text-xs px-6 py-3"
        style={{
          borderTop: `2px solid ${color}`,
          height: 50,
        }}
      >
        <div className="flex items-center">
          {logo && <Image image={logo} forceWidth={36} />}
          <Text
            tag="div"
            use="span"
            options={{
              font: "font-header",
              size: "text-xs",
              style: "uppercase",
            }}
            className="text-gray ml-2"
          >
            {companyName}
          </Text>
        </div>

        {onFirstPage ? (
          <div className="ml-auto text-right font-body text-gray-3">
            <Text
              tag="div"
              use="span"
              options={{ font: "font-body", size: "text-xs" }}
              className="whitespace-pre-wrap"
            >
              {contact}
            </Text>
          </div>
        ) : (
          <div className="Footer__page ml-auto font-header text-gray text-sm" />
        )}
      </div>
    </footer>
  );
};

Footer.propTypes = {
  onFirstPage: PropTypes.bool,
};

export default Footer;
